import { useEffect, useState } from "react";
import { useApolloClient } from "@apollo/react-hooks";
import {
  GET_MATERIAL_NAME_BY_ID,
  GET_MATERIAL_DETAILS,
  GET_MATERIAL_NAMES_BY_IDS,
} from "../CCCarbonMetal/components/CarbonMetalProcess/components/getStepDetail";

export const useGetMaterialName = (material_id) => {
  const client = useApolloClient();
  const [materialName, setMaterialName] = useState("");

    useEffect(() => {
        const getMaterialName = () => {
            client
                .query({
                    query: GET_MATERIAL_NAME_BY_ID,
                    variables: { material_id: material_id },
                })
                .then(({ data }) => {
                    // console.log("res: ", data);
                    setMaterialName(data.getMaterialNameById.name);
                })
                .catch((error) => {
                    console.log("Error: ", error);
                });
        };
        getMaterialName();
    }, []);
    return materialName;
};

// Returns external material link from material details query
export const useGetMaterialLink = (material_id) => {
  const client = useApolloClient();
  const [materialLink, setMaterialLink] = useState("");

  useEffect(() => {
    if (!material_id) return;

    const getMaterialLink = () => {
      client
        .query({
          query: GET_MATERIAL_DETAILS,
          variables: { material_id },
        })
        .then(({ data }) => {
          const link =
            data?.getMaterialDetailWithPrices?.data?.[0]?.material_id?.link ||
            "";
          setMaterialLink(link);
        })
        .catch((error) => {
          console.log("Error: ", error);
        });
    };

    getMaterialLink();
  }, [client, material_id]);

  return materialLink;
};

// Batch fetch material names by IDs
export const useGetMaterialNamesByIds = (material_ids) => {
  const client = useApolloClient();
  const [materialNamesMap, setMaterialNamesMap] = useState({});
  const [materialNamesArray, setMaterialNamesArray] = useState([]);

  useEffect(() => {
    if (!material_ids || material_ids.length === 0) {
      return;
    }

    // Filter out invalid IDs and ensure uniqueness
    const validIds = [...new Set(material_ids.filter(id => id && !isNaN(id) && id > 0))];
    
    if (validIds.length === 0) {
      return;
    }

    const getMaterialNames = () => {
      client
        .query({
          query: GET_MATERIAL_NAMES_BY_IDS,
          variables: { material_ids: validIds },
        })
        .then(({ data }) => {
          const materials = data?.getMaterialNamesByIds || [];
          // Create a map for easy lookup by material_id
          const materialMap = {};
          materials.forEach(material => {
            if (material?.material_id) {
              materialMap[material.material_id] = material.name;
            }
          });
          setMaterialNamesMap(materialMap);
          setMaterialNamesArray(materials);
        })
        .catch((error) => {
          console.log("Error fetching material names: ", error);
        });
    };
    getMaterialNames();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [material_ids?.join(',')]);

  return { materialNamesMap, materialNamesArray };
};
